import { useQuery } from "@tanstack/react-query";
import { Button, Divider, Form, Switch } from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import { getLocations } from "../../network/settings";

type Props = {};

const TeamMemberCommissions = (props: Props) => {
  const { data: locations } = useQuery(["location"], () => getLocations());
  console.log(locations);
  const intl = useIntl();
  const onFinish = (values: any) => {
    console.log(values);
  };
  return (
    <div>
      <div className="text-color-primary text-2xl font-semibold leading-7 flex items-center gap-2 text-end">
        <FormattedMessage id="commissionSettingsTitle" />
      </div>
      <div className="my-4 text-color-gray text-base font-normal leading-7 ">
        <FormattedMessage id="commissionSettingsDescription" />
      </div>
      <div>
        <Form name="commissions" onFinish={onFinish} className="">
          <div className="w-full flex flex-col py-6 px-4 gap-4 items-center justify-center mt-1 bg-[#EEF0FF] rounded-lg">
            <div className="bg-white rounded-lg p-4 w-full">
              <h5 className=" text-color-primary bg-[#EEF0FF] w-fit rounded-lg  font-normal text-sm">
                <FormattedMessage id="teamCommissionAccountTitle" />
              </h5>
              <h5 className=" font-normal text-sm text-black mt-3">
                <span className="text-[#75757E]">
                  <FormattedMessage id="branches" />
                </span>
                :
                {locations?.data?.map((e: any) => (
                  <span>{e?.name}</span>
                ))}
              </h5>
              <Divider className="!my-2" />
              <Form.Item
                className="w-full !mb-0"
                name="switch"
                valuePropName="checked"
              >
                <div className="flex items-center justify-between">
                  <span>
                    {intl.formatMessage({
                      id: "calculateCommissionBeforeDiscounts",
                    })}
                  </span>
                  <Switch />
                </div>
              </Form.Item>
              <Form.Item
                className="w-full !mb-0"
                name="switch"
                valuePropName="checked"
              >
                <div className="flex items-center justify-between">
                  <span>
                    {intl.formatMessage({ id: "calculateCommissionWithTax" })}
                  </span>
                  <Switch />
                </div>
              </Form.Item>
              <Form.Item
                className="w-full !mb-0"
                name="switch"
                valuePropName="checked"
              >
                <div className="flex items-center justify-between">
                  <span>
                    {intl.formatMessage({
                      id: "calculateCommissionBeforeMembershipDiscount",
                    })}
                  </span>
                  <Switch />
                </div>
              </Form.Item>
            </div>
          </div>
          <div className="flex items-center justify-end gap-4 w-full my-6">
            <Button
              type="primary"
              className="bg-color-primary h-full text-white text-lg rounded-md px-2 w-fit min-w-[200px]"
              htmlType="submit"
            >
              {intl.formatMessage({
                id: "saveChanges",
                defaultMessage: "حفظ التغييرات",
              })}{" "}
            </Button>
            <Button
              type="primary"
              // onClick={() => close()}
              className="bg-color-light h-full border-[#FBFBFF] text-black text-lg rounded-md px-2 w-fit min-w-[200px]"
              htmlType="button"
            >
              {intl.formatMessage({
                id: "cancel",
                defaultMessage: "إلفاء",
              })}
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default TeamMemberCommissions;
